export interface UserForm {
  name: string;
  forms: UserFormSection[];
}

export interface UserFormSection {
  form_name: string;
  section_name: string;
  page_name: string;
  fields: UserFormField[];
}

export interface UserFormField {
  id: string;
  name: string;
  label: string;
  type: 'text' | 'date' | 'checkbox';
  disabled: boolean;
  notes: UserFormFieldNotes;
  canEdit: boolean;
  required: boolean;
  visible: string[] | null;
  value: UserFormFieldValue | null;
  preview?: UserFormFieldPreview[];
}

export interface UserFormFieldPreview {
  source: 'value' | 'notes.text';
  label?: string;
}

export interface UserFormFieldValue {
  context: unknown;
  field: string;
}

export interface UserFormFieldNotes {
  disabled: boolean;
  text: string;
  maxLength?: number;
}

export const WORKING_EXPERIENCE: UserForm = {
  name: 'performance',
  forms: [
    {
      form_name: 'service-length-1',
      section_name: 'service_length',
      page_name: 'performance',
      fields: [
        {
          id: 'anzianita-pubblica-amministrazione',
          name: 'anzianita-pubblica-amministrazione',
          label: 'Anzianità nella pubblica amministrazione',
          type: 'text',
          disabled: true,
          notes: {
            disabled: true,
            text: '',
            maxLength: 400,
          },
          canEdit: true,
          required: true,
          visible: [
            'A1',
            'A2',
            'A3',
            'A4',
            'B1',
            'B2',
            'B3',
            'B4',
            'C1',
            'C2',
            'C3',
            'C4',
            'C5',
            'IST3',
            'IST4',
            'IST5',
            'ISPTI3',
            'IVC3',
            'IVC4',
            'IVC5',
            'I1',
            'I2',
            'I3',
            'I4',
            'P1',
            'P2',
            'P3',
            'P4',
          ],
          value: {
            context: 'currentUser',
            field: 'anzianitaPubblicaAmministrazione',
          },
          preview: [
            {
              source: 'notes.text',
              label:
                'Note di modifica Anzianità nella pubblica amministrazione',
            },
          ],
        },
        {
          id: 'data-assunzione-in-enac',
          name: 'data-assunzione-in-enac',
          label: 'Data assunzione in ENAC',
          type: 'text',
          disabled: true,
          notes: {
            disabled: true,
            text: '',
            maxLength: 400,
          },
          canEdit: true,
          required: true,
          visible: [
            'A1',
            'A2',
            'A3',
            'A4',
            'B1',
            'B2',
            'B3',
            'B4',
            'C1',
            'C2',
            'C3',
            'C4',
            'C5',
            'IST3',
            'IST4',
            'IST5',
            'ISPTI3',
            'IVC3',
            'IVC4',
            'IVC5',
            'I1',
            'I2',
            'I3',
            'I4',
            'P1',
            'P2',
            'P3',
            'P4',
          ],
          value: { context: 'currentUser', field: 'dataAssunzioneInEnac' },
          preview: [
            {
              source: 'notes.text',
              label: 'Note di modifica Data assunzione in ENAC',
            },
          ],
        },
        {
          id: 'anzianita-categoria-attuale',
          name: 'anzianita-categoria-attuale',
          label: 'Anzianità nella categoria attuale',
          type: 'text',
          disabled: true,
          notes: {
            disabled: true,
            text: '',
            maxLength: 400,
          },
          canEdit: true,
          required: true,
          visible: [
            'A1',
            'A2',
            'A3',
            'A4',
            'B1',
            'B2',
            'B3',
            'B4',
            'C1',
            'C2',
            'C3',
            'C4',
            'C5',
            'IST3',
            'IST4',
            'IST5',
            'ISPTI3',
            'IVC3',
            'IVC4',
            'IVC5',
            'I1',
            'I2',
            'I3',
            'I4',
            'P1',
            'P2',
            'P3',
            'P4',
          ],
          value: { context: 'currentUser', field: 'anzianitaCategoriaAttuale' },
          preview: [
            {
              source: 'notes.text',
              label: 'Note di modifica Anzianità nella categoria attuale',
            },
          ],
        },
        {
          id: 'anzianita-servizio',
          name: 'anzianita-servizio',
          label: 'Anzianità nel livello attuale',
          type: 'text',
          disabled: true,
          notes: {
            disabled: true,
            text: '',
          },
          canEdit: false,
          required: true,
          visible: ['all'],
          value: { context: 'currentUser', field: 'anzianitaLivelloAttuale' },
        },
      ],
    },
  ],
};

export const PRIVACY_POLICY: UserForm = {
  name: 'personal_info',
  forms: [
    {
      form_name: 'privacy-form-1',
      section_name: 'privacy_form',
      page_name: 'personal_info',
      fields: [
        {
          id: 'privacy-check',
          name: 'privacy-check',
          label: 'Accetto le condizioni del testo sopracitato.',
          type: 'checkbox',
          disabled: false,
          notes: {
            disabled: true,
            text: '',
          },
          canEdit: false,
          required: true,
          visible: null,
          value: {
            context: 'currentUser',
            field: 'privacy-check',
          },
        },
      ],
    },
  ],
};
